function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { ItemType, TopicPage_ViewsTopicFragmentDoc, useTopicPage_CreateSectionMutation } from "sprout-graphql";
import update from "immutability-helper";
import { NewItemInput } from "sprout-ui-dom";
import useUpdateItem from "@sprout/client-graphql/dist/mutations/useUpdateItem";
import { generateOptimisticId, generateRandomKey } from "@sprout/client-lib";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { useTopicPageViewsTopicEditor } from "../TopicPage_Views_Topic/TopicPageViewsTopicEditorContext";
const TopicPageSectionInput = (props)=>{
    const { open , section , topic  } = props;
    const { dispatch  } = useTopicPageViewsTopicEditor();
    const handleCancel = useCallback(()=>{
        dispatch({
            type: "CLOSE_EDITOR"
        });
    }, [
        dispatch
    ]);
    const showSnackbar = useSnackbar();
    const currentUser = useCurrentUser();
    const updateSection = useUpdateItem();
    const [createSection] = useTopicPage_CreateSectionMutation();
    const handleSubmit = useCallback((title)=>{
        if (section) {
            updateSection({
                itemId: section.id,
                title
            });
            handleCancel();
        } else if (topic) {
            const { rootTopicOrSelf  } = topic;
            createSection({
                variables: {
                    parentTopicId: topic.id,
                    title
                },
                optimisticResponse: {
                    createItem: {
                        item: {
                            id: generateOptimisticId(),
                            nodeId: generateRandomKey(),
                            type: ItemType.Topic,
                            __typename: "Item",
                            title,
                            description: null,
                            linkImages: [],
                            directPostCount: 0,
                            directSubtopicCount: 0,
                            checklistItemCompletedCount: 0,
                            parentTopic: topic,
                            owner: currentUser || null,
                            rootTopic: rootTopicOrSelf || null,
                            isArchived: false,
                            isExplicitlyArchived: false,
                            archivedAt: null,
                            deletedAt: null,
                            isExplicitlyDeleted: false,
                            userPreferences: null,
                            posts: {
                                totalCount: 0,
                                nodes: [],
                                __typename: "ItemsConnection"
                            },
                            sections: {
                                nodes: [],
                                __typename: "ItemsConnection"
                            }
                        },
                        __typename: "CreateItemPayload"
                    }
                },
                update (proxy, { data  }) {
                    var ref;
                    const options = {
                        id: topic.nodeId,
                        fragment: TopicPage_ViewsTopicFragmentDoc,
                        fragmentName: "TopicPage_ViewsTopic"
                    };
                    const cache = proxy.readFragment(options);
                    const item = data === null || data === void 0 ? void 0 : (ref = data.createItem) === null || ref === void 0 ? void 0 : ref.item;
                    if (item) proxy.writeFragment(_objectSpread({}, options, {
                        data: update(cache, {
                            sections: {
                                nodes: {
                                    $apply: (nodes)=>[
                                            _objectSpread({}, item, {
                                                // it does not matter what the position is
                                                position: -1
                                            }),
                                            ...nodes.filter(({ id  })=>id !== item.id), 
                                        ]
                                }
                            }
                        })
                    }));
                }
            }).catch(()=>{
                showSnackbar.error();
            });
            dispatch({
                type: "SET_EDITOR",
                payload: {
                    editor: "CREATE_POST",
                    editorPosition: Number.MIN_SAFE_INTEGER
                }
            });
        } else handleCancel();
    }, [
        section,
        topic,
        handleCancel,
        updateSection,
        createSection,
        currentUser,
        dispatch,
        showSnackbar, 
    ]);
    return /*#__PURE__*/ _jsx(NewItemInput, {
        initialInputValue: (section === null || section === void 0 ? void 0 : section.title) || undefined,
        open: open,
        onCancel: handleCancel,
        onSubmit: handleSubmit,
        placeholder: `Like "Recipes"`
    });
};
export default TopicPageSectionInput;
